module.exports = __webpack_public_path__ + "static/images/search-empty.845f1e6.png";